"use strict";

define('view/html.viewer',['underscore', '../templates', 'uikit/elements/text', 'uikit/elements/checkbox', 'uikit/collections/checkbox.group', 'uikit/collections/list'], function (_, Templates, TextView, CheckboxView, CheckboxGroup, ListView) {
  var HtmlViewer = TextView.extend({
    tagName: 'div',
    options: _.extend({}, TextView.prototype.options, {
      placeholder: '--'
    }),
    template: Templates.IRB['html.viewer']
  });
  var HTMLCheckbox = CheckboxView.extend({
    template: Templates.IRB['html.viewer.checkbox']
  });
  HtmlViewer.CheckboxGroup = CheckboxGroup.extend({
    childView: HTMLCheckbox
  });
  var HTMLListItem = ListView.prototype.childView.extend({
    template: Templates.IRB['html.viewer.list.item']
  });
  HtmlViewer.List = CheckboxGroup.extend({
    childView: HTMLListItem
  });
  return HtmlViewer;
});

